import { Informations } from '../../components';
import { homeObjOne, homeObjThree } from './Data';

const Signup = () => {
  return (
    <>
      <Informations {...homeObjOne} />
      <Informations {...homeObjThree} />
    </>
  );
}

export default Signup;
